/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetSampleRequestQueryResponse,
  GetSampleRequestPathParams,
  GetSampleRequest404,
} from '../types/GetSampleRequest'

function getGetSampleRequestUrl({
  id,
}: {
  id: GetSampleRequestPathParams['id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/samples/sample-requests/${id}/` as const,
  }
  return res
}

/**
 * @description Retrieve a single sample request with detailed serialization.
 * @summary Get sample request detail
 * {@link /api/v1/samples/sample-requests/:id/}
 */
export async function getSampleRequest(
  { id }: { id: GetSampleRequestPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetSampleRequestQueryResponse,
    ResponseErrorConfig<GetSampleRequest404>,
    unknown
  >({
    method: 'GET',
    url: getGetSampleRequestUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
